import {StackedSymbol} from '@gongxigames/framework/slot/modules/reels/StackedSymbol';
import {EaseFunction} from '@gongxigames/framework/core';

export interface ReelsConfig {
    defaultSymbolsOrder: (number | number[])[];
    oversizeSymbols: number[];
    symbolsWithHitAnimation: number[];
    reelsSpeedLevels: ReelSpeedConfig[];
    scatterIndex?: number;
    stackedSymbols?: StackedSymbol[];
    rubySymbol?: number;
    blur?: number;
    symbolsSprites: {[symbolID: number]: string;};
    minScattersForFreeGames?: number;
    /**
     * time to automatically close game popups (FG intro / outro, respins, pick bonuses)
     * if it equals -1, it means we don't implement it
     */
    autoClosePopupTimeout?: number; // TODO: Way we have popup config in reels config? need to be refactored...
}

export type ReelSpeedConfig = {
    /**
     * speed in pixels per frame
     */
    speed: number;

    /**
     * full time from start spinning till the last reel stop bouncing.
     * if it equals -1, it means we calculate it
     */
    fullStopTime: number;

    /**
     * time to start stopping first reel.
     */
    firstReelStopTime: number;

    /**
     * delay to stop next reel.
     * if it equals -1, it means we calculate it
     */
    betweenReelsStopDelay: number;

    /**
     * time for bounce effect of stopping
     */
    stopBounceTime: number;

    /**
     * type of bounce effect of stopping
     */
    stopBounceEffect: EaseFunction;

    /**
     * time to automatically close game popups (FG intro / outro, respins, pick bonuses)
     * if it equals -1, it means we don't implement it
    */
    autoClosePopupTimeout: number; // TODO: why 'autoClosePopupTimeout' config in reel speed configs?
};
